import { Card, Descriptions, Typography } from 'antd';
import { useAuth } from '../context/AuthContext';

const { Title } = Typography;

function Profile() {
  const { user } = useAuth();
  const email = user?.email || user?.unique_name || user?.sub || '未設定';
  const userName = user?.name || user?.username || email;
  const role = user?.role || user?.roles || '未設定';

  return (
    <div style={{ maxWidth: 1200, margin: '0 auto' }}>
      <Title level={2}>個人資料</Title>
      <Card>
        <Descriptions column={1} items={[
          { key: 'username', label: '用戶名稱', children: userName },
          { key: 'email', label: '郵箱', children: email },
          { key: 'role', label: '角色', children: Array.isArray(role) ? role.join('、') : role },
        ]} />
      </Card>
    </div>
  );
}

export default Profile;
